import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/error.tsx")